export const initialState = () => ({})
